/**
 * HeaderBrowseSlot 컴포넌트
 * @description 헤더의 가장 흔한 모양 — 뒤로가기 · 제목 · 오른쪽 동작. 시안 `.3.0/slot/header/browse`.
 *   화면 대부분이 이 모양이라 껍데기가 기본으로 품는다.
 */
import { IconButton } from "@fanwork-web/design-system";
import { ChevronLeft } from "lucide-react";
import { memo } from "react";

import { headerStyles } from "./Header.styles";
import type { HeaderBrowseSlotProps } from "./Header.types";

/** 시안의 헤더 글리프는 본문 아이콘보다 한 단계 크다 */
const GLYPH_SIZE = 24;
/** 앱 `common:accessibility.back` */
const BACK_LABEL = "Back";

const HeaderBrowseSlot = memo<HeaderBrowseSlotProps>(
  ({ title, titleTrailing, onBack, following, backAccessibilityLabel }) => (
    <>
      {onBack ? (
        <IconButton
          icon={<ChevronLeft size={GLYPH_SIZE} />}
          label={backAccessibilityLabel ?? BACK_LABEL}
          tone="ghost"
          size="md"
          radius="circle"
          onClick={onBack}
        />
      ) : null}
      {/* 제목이 없어도 자리는 남는다 — 오른쪽 슬롯이 끝에 붙어 있어야 한다 */}
      <div className={headerStyles.lead}>
        <h1 className={headerStyles.title}>{title}</h1>
        {titleTrailing}
      </div>
      {following ? (
        <div className={headerStyles.following}>{following}</div>
      ) : null}
    </>
  ),
);

HeaderBrowseSlot.displayName = "HeaderBrowseSlot";

export default HeaderBrowseSlot;
